import React from "react";
import { Box, Stack } from "@mui/material";
import PanelHeader from "~/pages/player/components/PanelHeader";
import { usePanelContext } from "~/pages/player/panels";

export interface PanelLayoutProps {
  contentRef?: React.RefCallback<HTMLElement>;
  controls?: React.ReactNode;
  children: React.ReactNode;
}

export default function PanelLayout({
  contentRef,
  controls,
  children,
}: PanelLayoutProps) {
  const panel = usePanelContext();

  return (
    <Stack sx={{ height: 1, width: 1 }}>
      <Box
        sx={{
          height: 40,
          flexShrink: 0,
          overflow: "hidden",
          px: 0.5,
          borderBottom: 1,
          borderColor: "divider",
        }}
      >
        <PanelHeader />
      </Box>
      <Box
        sx={{
          flexGrow: 1,
          minHeight: 0,
          // Overflow cannot be allowed on this element as it could possibly
          // have its size observed via the `contentRef`. This can (and has)
          // led to some nasty bugs if a scrollbar appears, causing the
          // element's content box size to change, causing resizes, and on
          // and on
          overflow: "hidden",
          position: "relative",
        }}
        ref={contentRef}
      >
        {children}
        {panel.isInitialized && panel.showPanelControls && controls}
      </Box>
    </Stack>
  );
}
